<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="20">
                    <a-row :gutter="20">
                        <a-col :span="5">
                            <a-input v-model="keyword" placeholder="请输入订单编号" />
                        </a-col>
                        <a-col :span="5">
                            <a-select
                                :value="search_user_value"
                                show-search
                                placeholder="请输入关键词搜索用户"
                                :show-arrow="true"
                                :filter-option="false"
                                :not-found-content="search_fetching ? undefined : null"
                                @search="searchUserSearch"
                                @change="searchUserChange"
                            >
                                <a-select-option key="">所有用户</a-select-option>
                                <a-spin v-if="search_fetching" slot="notFoundContent" size="small" />
                                <a-select-option v-for="d in search_user_list" :key="d.id">{{ d.truename+' ('+d.mobile+')' }}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="user" slot-scope="text, record">
                <div v-if="record.uid===0">所有用户</div>
                <div v-else>
                    {{record.users_truename}}
                    ({{record.users_mobile}})
                </div>
            </template>
            <template slot="content_arr" slot-scope="text, record">
                <div>
                     套餐名称：{{record.package_data_arr.name}}
                </div>
                <div>
                     套餐价格：{{record.package_data_arr.price}}元
                </div>
                <div>
                     套餐时长：{{record.package_data_arr.day}}天
                </div>
            </template>
            <template slot="us" slot-scope="text, record">
                <div>
                    {{record.us_truename}}
                    ({{record.us_mobile}}),{{record.us_id}}
                </div>
            </template>
<!--            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('info_edit')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('info_del')">删除</a>
            </template> -->
        </a-table>
    </div>
</template>

<script>
    import Func from '../../common/func'
    // import AEditor from '../../components/AEditor';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '用户',
            dataIndex: 'users_username',
            key: 'users_username',
            width: 200,
            scopedSlots: { customRender: 'user' },
        },
        {
            title: '用户ID',
            dataIndex: 'uid',
            key: 'uid',
        },
        {
            title: '订单编号',
            dataIndex: 'order_sn',
            key: 'order_sn',
        },
        // {
        //     title: '第三方编号',
        //     dataIndex: 'tran_id',
        //     key: 'tran_id',
        // },
        {
            title: '支付金额',
            dataIndex: 'money',
            key: 'money',
        },
        {
            title: '套餐信息',
            dataIndex: 'content_arr',
            key: 'content_arr',
            scopedSlots: { customRender: 'content_arr' },
        },
        {
            title: '开始时间',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: '结束时间',
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: '支付方式',
            dataIndex: 'pay_type_str',
            key: 'pay_type_str',
        },
        {
            title: '支付时间',
            dataIndex: 'pay_time',
            key: 'pay_time',
            width: 180,
        },
        {
            title: '订单推荐人',
            dataIndex: 'us',
            key: 'us',
            scopedSlots: { customRender: 'us' },
        },
        // {
        //     title: '修改时间',
        //     dataIndex: 'modified',
        //     key: 'modified',
        //     width: 180,
        // },
        // {
        //     title: '操作',
        //     dataIndex: 'id',
        //     width: 180,
        //     key:'operation',
        //     scopedSlots: { customRender: 'operation' },
        // },
    ];
    let add_timeout;
    let update_timeout;
    let search_timeout;
    export default {
        name: 'Info',
        // components: { AEditor },
        data(){
            return {
				is_empty:'',
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,

                search_fetching: false,
                search_user_value:undefined,
                search_user_list:[],


                add_fetching: false,
                update_fetching: false,
                add_user_value:undefined,
                update_user_value:undefined,
                add_user_list:[],
                update_user_list:[],
                group_list:[],
                info_add:{
                    uid:'',
                    title:'',
                    content:''
                },
                info_update:{
                    id:0,
                    uid:'',
                    title:'',
                    content:''
                },
                add_rules: {
                    username:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
                },
                update_rules: {
                    username:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
            //指定用户 begin
            searchUserSearch(keyword) {
                if (search_timeout) {
                    clearTimeout(search_timeout);
                    search_timeout = null;
                }
                search_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.search_user_list = res.info.list;
                    });
                }, 300);
            },
            searchUserChange(value) {
                this.search_user_value=value;
            },


            //指定用户 begin
            addUserSearch(keyword) {
                if (add_timeout) {
                    clearTimeout(add_timeout);
                    add_timeout = null;
                }
                add_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.add_user_list = res.info.list;
                    });
                }, 300);
            },
            addUserChange(value) {
                this.info_add.uid = value;
                this.add_user_value=value;
            },
            updateReferrerSearch(keyword) {
                if (update_timeout) {
                    clearTimeout(update_timeout);
                    update_timeout = null;
                }
                update_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.update_user_list = res.info.list;
                    });
                }, 300);
            },
            updateReferrerChange(value) {
                this.info_update.uid = value;
                this.update_user_value=value;
            },
            //指定用户 end
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'car.order_list',
                    uid:this.search_user_value||'',
                    keyword: keyword,
                    page: page,
					// is_empty:this.is_empty,
                },(res) => {
					if (res.error === 0) {
						this.tableData = res.info.list;
						var pagination={
							pageSize:10,
							total:res.info.foot.total,
							current:parseInt(res.info.foot.current)
						}
						this.page=pagination;
						this.loading = false
					} else {
						this.$message.error(res.info);
					}
                });
            },

            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'info.add_data',
                            ...this.info_add
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },

            save_data(e){
                e.preventDefault();
                this.$refs.update_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'info.save_data',
                            ...this.info_update
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.update_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                item.password='';
                this.update_user_value=item.uid;
                Func.url_get({
                    action:'users.search_one',
                    keyword:item.uid
                },(res) => {
                    this.update_user_list = res.info.list;
                });
                this.info_update=item;
                this.update_model=true;
            },

            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'info.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            goto_url(url,id){
                this.$router.push({
                    path:'/admin/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
</style>